(function(){
if(window.__akcMotion)return;window.__akcMotion=true;
const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
const controllers=new Map();
const icon='<svg data-motion-pause viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><rect x="5" y="4" width="3" height="12" rx="1"/><rect x="12" y="4" width="3" height="12" rx="1"/></svg><svg data-motion-play viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path d="M6 3.5a1 1 0 0 1 1.5-.85l10 6.5a1 1 0 0 1 0 1.7l-10 6.5A1 1 0 0 1 6 16.5z"/></svg>';
function init(root){
if(controllers.has(root))return;
const track=root.querySelector('[data-circle-track]');
if(!track||track.children.length<2)return;
const button=document.createElement('button');button.type='button';button.className='akc-motion-toggle';button.innerHTML=icon;root.appendChild(button);
const abort=new AbortController(),options={signal:abort.signal};
let userPaused=reduced.matches||Boolean(window.Shopify&&window.Shopify.designMode),hover=false,focus=false,visible=false,enabled=false,frame=0,last=0,x=track.scrollLeft,step=0;
function paint(){
button.hidden=!enabled;button.dataset.paused=String(userPaused);
button.setAttribute('aria-label',userPaused?root.dataset.play:root.dataset.pause);
button.title=userPaused?root.dataset.play:root.dataset.pause;
root.dataset.circleState=!enabled?'idle':userPaused||hover||focus?'paused':visible&&!document.hidden?'running':'waiting';
}
function stop(){if(frame)cancelAnimationFrame(frame);frame=0;last=0;}
function allowed(){return enabled&&!userPaused&&!hover&&!focus&&visible&&!document.hidden&&root.isConnected;}
function tick(now){
frame=0;if(!allowed()){paint();return;}
const delta=last?Math.min((now-last)/1000,.05):0;last=now;x+=delta*16;
if(x>=step){
const first=track.firstElementChild;
if(first&&first.contains(document.activeElement)){focus=true;stop();paint();return;}
track.appendChild(first);x-=step;
}
track.scrollLeft=x;frame=requestAnimationFrame(tick);
}
function start(){
step=track.firstElementChild.getBoundingClientRect().width+(parseFloat(getComputedStyle(track).columnGap)||0);
enabled=step>0&&track.scrollWidth-track.clientWidth>step+2;
paint();if(allowed()&&!frame){x=track.scrollLeft;last=0;frame=requestAnimationFrame(tick);}else if(!allowed())stop();}
function measure(){x=track.scrollLeft;start();}
function pause(){userPaused=true;start();}
track.addEventListener('pointerdown',pause,{passive:true,signal:abort.signal});
track.addEventListener('wheel',pause,{passive:true,signal:abort.signal});
track.addEventListener('click',pause,options);
track.addEventListener('scroll',()=>{if(frame&&Math.abs(track.scrollLeft-x)>2)pause();},{passive:true,signal:abort.signal});
root.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'){hover=true;start();}},options);
root.addEventListener('pointerleave',e=>{if(e.pointerType==='mouse'){hover=false;start();}},options);
root.addEventListener('focusin',e=>{focus=track.contains(e.target);start();},options);
root.addEventListener('focusout',e=>{focus=Boolean(e.relatedTarget&&track.contains(e.relatedTarget));start();},options);
button.addEventListener('click',()=>{userPaused=!userPaused;start();},options);
document.addEventListener('visibilitychange',start,options);
window.addEventListener('resize',measure,options);
reduced.addEventListener('change',()=>{userPaused=reduced.matches;start();},options);
const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;start();},{threshold:.1});observer.observe(track);
const resize=new ResizeObserver(measure);resize.observe(track);
root.dataset.circleReady='true';
controllers.set(root,()=>{stop();abort.abort();observer.disconnect();resize.disconnect();button.remove();controllers.delete(root);});
measure();
}
function boot(scope){scope.querySelectorAll('[data-ak-circles]').forEach(init);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot(document));else boot(document);
document.addEventListener('shopify:section:load',e=>boot(e.target));
document.addEventListener('shopify:section:unload',e=>controllers.forEach((destroy,root)=>{if(e.target.contains(root))destroy();}));
})();